import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/newspaper': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M552 64c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24h-496c-30.9 0-56-25.1-56-56v-272c0-13.3 10.7-24 24-24h42.8c6.6-18.6 24.4-32 45.2-32h440zM48 392c0 4.4 3.6 8 8 8s8-3.6 8-8v-248h-16v248zM528 400v-288h-416v280c0 2.7-0.2 5.4-0.6 8h416.6zM172 280c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v96c0 6.6-5.4 12-12 12h-136zM200 200v40h80v-40h-80zM160 340v-24c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-136c-6.6 0-12-5.4-12-12zM352 340v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12zM352 196v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12zM352 268v-24c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/newspaper.js
// module id = 1800
// module chunks = 0